import { render, staticRenderFns } from "./manageOrderById.vue?vue&type=template&id=66746184&"
import script from "./manageOrderById.vue?vue&type=script&lang=js&"
export * from "./manageOrderById.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports